import { DialogModal } from 'components/DialogModal'

import {
  VENUE_SETTINGS_FIELDS_REQUIRED_CONFIRMATION,
  venueSettingsItems,
} from 'resources'

const ConfirmationModal = ({
  onCloseModal,
  handleConfirmationCallback,
  setFieldValue,
  values,
  isOpenDialogModal,
}) => {
  const currentSetting = venueSettingsItems.find((setting) =>
    VENUE_SETTINGS_FIELDS_REQUIRED_CONFIRMATION.includes(setting.name)
  )

  return (
    <DialogModal
      closeModalCallback={() =>
        onCloseModal(setFieldValue, currentSetting.name)
      }
      confirmationCallback={() => handleConfirmationCallback(values)}
      modalBody={
        <div className="dialog-modal__body-text">
          {currentSetting.dialogModalText}
        </div>
      }
      modalButtonText="confirm"
      modalIsOpen={isOpenDialogModal}
      modalTitle={currentSetting.title}
    />
  )
}

export default ConfirmationModal
